import { Dispatch } from 'react';
import { DeckAction } from '../context/DeckContextV3';
import { Block, Edge } from 'src/types/shared/blocksV3';
import getDefaultBumpout from './getDefaultBumpout';

const handleAddBumpout = ({
	dispatch,
	block,
	edge,
}: {
	dispatch: Dispatch<DeckAction>;
	block: Block;
	edge: Edge;
}) => {
	const defaultBumpout = getDefaultBumpout(block, edge);

	if (defaultBumpout)
		dispatch({
			type: 'ADD_BUMPOUT',
			payload: defaultBumpout,
		});
};

export default handleAddBumpout;
